<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/ArchivoAdjunto`;

// Parametros
// Id Familia 
// 1 : Cluster Cabecera
// 2 : Cluster Detalle
// 3 : Ventas Adjunto
// 4 : Pagos Ventas Adjunto

// IdTipoArchivo 
// 1. documento
// 2. imagen 
// 3. video url

// idTipoAdjuntoVenta ver tabla VentaTiposAdjuntos

function authHeaders() {
  return {
    'Authorization': `Bearer ${utilsService.getToken()}`,
  };
}

async function subirArchivos(familia, idTipoArchivo, idItem, files, idTipoAdjuntoVenta = null, observacion = '') {
  const idUsuario = Number(localStorage.getItem('user-id'));
  const formData = new FormData();
  formData.append('IdFamilia', familia);
  formData.append('IdTipoArchivo', idTipoArchivo);
  formData.append('IdItem', idItem);
  formData.append('Observacion', observacion || '');
  formData.append('IdUsuarioCreacion', idUsuario);
  
  if (idTipoAdjuntoVenta !== null && idTipoAdjuntoVenta !== undefined) {
    formData.append('IdTipoAdjuntoVenta', idTipoAdjuntoVenta);
  }
  for (const file of files) {
    formData.append('files', file);
  }
  const response = await axios.post(`${apiUrl}/crear`, formData, {
    headers: authHeaders(),
  });
  return response.data;
}

async function getArchivosByItem(idItem, familia) {
  const response = await axios.get(`${apiUrl}/familia/${familia}/item/${idItem}`, {
    headers: authHeaders(),
  });
  return response.data;
}

async function eliminarArchivo(id) {
  const idUsuario = Number(localStorage.getItem('user-id'));
  const response = await axios.delete(`${apiUrl}/eliminar/${id}`, {
    headers: authHeaders(),
    params: { idUsuarioModificacion: idUsuario },
  });
  return response.data;
}

export default {
  subirArchivos,
  getArchivosByItem,
  eliminarArchivo,
};
</script>
